<template>
  <div>
    <div class="flex flex-wrap justify-center">
      <div class="w-full xl:w-8/12 px-2">
        <card-my-team
          :id="team.id"
          :image="team.image"
          :name="team.name"
          :owner="team.owner"
          :description="team.description"
        />
      </div>
    </div>
    <div
      class="mt-10 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-gray-500 mb-1 text-xs font-semibold">
              Overview
            </h6>
            <h2 class="text-black text-xl font-semibold">
              {{ team.name }} - Members
            </h2>
          </div>
        </div>
      </div>
      <div class="p-4 flex-auto">
        <div class="relative">
          <vue-good-table
            :columns="members_columns"
            :rows="members[0]"
            :lineNumbers="true"
            :search-options="{
              enabled: true,
              placeholder: 'Search Member'
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <div slot="emptystate" class="text-center">
              No members available.
            </div>
            <div slot="table-actions">
              <download-csv
                class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                :data="members[0]"
                type="button"
                name="members.csv"
              >
                <i class="fas fa-download"></i>
                Download CSV
              </download-csv>
            </div>
            ></vue-good-table
          >
        </div>
      </div>
    </div>
    <div
      class="mt-10 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-gray-500 mb-1 text-xs font-semibold">
              Overview
            </h6>
            <h2 class="text-black text-xl font-semibold">
              {{ team.name }} - Incidents
            </h2>
          </div>
        </div>
      </div>
      <div class="p-4 flex-auto">
        <div class="relative">
          <vue-good-table
            :columns="incidents_columns"
            :lineNumbers="true"
            :rows="incidents"
            :search-options="{
              enabled: true,
              placeholder: 'Search Incident'
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <div slot="emptystate" class="text-center">
              No incidents available.
            </div>
            <div slot="table-actions">
              <download-csv
                class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                :data="incidents"
                type="button"
                name="incidents.csv"
              >
                <i class="fas fa-download"></i>
                Download CSV
              </download-csv>
            </div>
            ></vue-good-table
          >
        </div>
      </div>
    </div>
    <div
      class="mt-10 relative flex flex-col min-w-0 break-words bg-white w-full mb-6 shadow-lg rounded"
    >
      <div class="rounded-t mb-0 px-4 py-3 bg-transparent">
        <div class="flex flex-wrap items-center">
          <div class="relative w-full max-w-full flex-grow flex-1">
            <h6 class="uppercase text-gray-500 mb-1 text-xs font-semibold">
              Overview
            </h6>
            <h2 class="text-black text-xl font-semibold">
              {{ team.name }} - Roles
            </h2>
          </div>
        </div>
      </div>
      <div class="p-4 flex-auto">
        <div class="relative">
          <vue-good-table
            :columns="roles_columns"
            :rows="roles[0]"
            :lineNumbers="true"
            :search-options="{
              enabled: true,
              placeholder: 'Search Role'
            }"
            :pagination-options="{
              enabled: true,
            }"
          >
            <div slot="emptystate" class="text-center">
              No roles available.
            </div>
            <div slot="table-actions">
              <download-csv
                class="bg-blue-600 text-white active:bg-pink-600 font-bold uppercase text-xs px-4 py-2 rounded shadow hover:shadow-md outline-none focus:outline-none mr-1 mb-1"
                :data="roles[0]"
                type="button"
                name="roles.csv"
              >
                <i class="fas fa-download"></i>
                Download CSV
              </download-csv>
            </div>
            ></vue-good-table
          >
        </div>
      </div>
    </div>
  </div>
</template>
<script>
/* 
  Class: Team
  Description: This class representing a main entry point for user team.
*/

/* Imports */
import TeamService from "@/services/team.service.js";
import CardMyTeam from "@/components/Cards/Teams/CardMyTeam.vue";
/* /Imports/ */

export default {
    /* 
      Define data with custom team state values. 
    */
    data() {
      return {
        members: [],
        members_columns: [
          {
            label: "First Name",
            field: "first_name",
            filterable: true,
          },
          {
            label: "Middle Name",
            field: "middle_name",
            filterable: true,
          },
          {
            label: "Last Name",
            field: "last_name",
            filterable: true,
          },
          {
            label: "Email",
            field: "email",
            filterable: true,
          },
        ],
        member_row: null,
        incidents: [],
        incidents_columns: [
          {
            label: "Number",
            field: "number",
            filterable: true,
          },
          {
            label: "Category Name",
            field: "category_name",
            filterable: true,
          },
          {
            label: "Short Description",
            field: "short_description",
            filterable: true,
          },
          {
            label: "Description",
            field: "description",
            filterable: true,
          },
          {
            label: "Caller",
            field: "caller",
            filterable: true,
          },
          {
            label: "Executor",
            field: "executor",
            filterable: true,
          },
          {
            label: "State",
            field: "state",
            filterable: true,
          },
          {
            label: "Impact",
            field: "impact",
            filterable: true,
          },
          {
            label: "Urgency",
            field: "urgency",
            filterable: true,
          },
          {
            label: "Priority",
            field: "priority",
            filterable: true,
          },
        ],
        incident_row: null,
        roles: [],
        roles_columns: [
          {
            label: "Name",
            field: "name",
            filterable: true,
          },
          {
            label: "Description",
            field: "description",
            filterable: true,
          },
        ],
        role_row: null,
        rows: this.team,
      };
  },
  
  /* 
    Define different components for reusability. 
  */
  components: {
    CardMyTeam
  },

  /* 
    Define props from which we got team data. 
  */
  props: {
    team: null,
    id: null
  },
  
  /* 
    Define watcher from which we got team, members, roles and incidents for that user team. 
  */
  watch: {
    "$route.params.id": {
      handler: function(id) {
        this.$loading(true);

        TeamService.getTeam(id).then((response) => {
          this.team = response.data.team;
          this.id = id;
          
          this.members.push(response.data.team.users);
          this.roles.push(response.data.team.roles);

          var incidents = response.data.team.incidents;

          for (var i = 0; i < incidents.length; i++) {
            this.incidents.push({
              id: incidents[i].id,
              number: "INC" + incidents[i].number,
              category_name: incidents[i].category_id[0].name,
              short_description: incidents[i].short_description,
              description: incidents[i].description,
              caller:
                incidents[i].caller[0].first_name +
                " " +
                incidents[i].caller[0].last_name,
              executor:
                incidents[i].executor[0].first_name +
                " " +
                incidents[i].executor[0].last_name,
              state: incidents[i].state,
              impact: incidents[i].impact,
              urgency: incidents[i].urgency,
              priority: incidents[i].priority,
              token_caller: incidents[i].caller[0].token,
              token_executor: incidents[i].executor[0].token
            });
          }

          this.$loading(false);
        });
      },
      deep: true,
      immediate: true,
    },
  },
};
</script>
